module.exports = __webpack_public_path__ + "static/MineralSwimV2_Testimonial_Well_Nourished-7afe9acfd3cffc05297540232933f5a0.jpg";